export class ShareKeyData {
    share_id: number;
    share_sequence: number;
    id?: number;
    enc_share_key: string;
    link_share_key?: string;
}
